const useElements = () => {
  const hideElement = async ({ step }) => {
    const elem = document.getElementById(step.elementId);

    if (elem == null) {
      return {
        error: true,
        message: `no element found with id ${step.elementId}`
      };
    }

    elem.classList.add('hidden');

    return {
      success: true,
      message: `added "hidden" class to html element with id ${step.elementId}`
    };
  };

  const showElement = async ({ step }) => {
    const elem = document.getElementById(step.elementId);

    if (elem == null) {
      return {
        error: true,
        message: `no element found with id ${step.elementId}`
      };
    }
    elem.classList.remove('hidden');
    return {
      success: true,
      message: `removed "hidden" class to html element with id ${step.elementId}`
    };
  };

  const toggleElement = async ({ step }) => {
    const elem = document.getElementById(step.elementId);
    let message = '';

    if (elem == null) {
      return {
        error: true,
        message: `no element found with id ${step.elementId}`
      };
    }

    if (elem.classList.contains('hidden')) {
      message = `removed "hidden" class to html element with id ${step.elementId}`;
      elem.classList.remove('hidden');
    } else {
      elem.classList.add('hidden');
      message = `added "hidden" class to html element with id ${step.elementId}`;
    }

    return {
      success: true,
      message
    };
  };

  return {
    hideElement,
    showElement,
    toggleElement
  };
};

export default useElements;
